import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route pathname changes.
 *
 * Without this, SPA navigation preserves the previous route's scroll position,
 * which in practice means:
 *  - Clicking a product card on the home page (user scrolled to "Featured
 *    Products") navigates to the PDP with the browser still scrolled down,
 *    placing the PDP's Add to Cart button directly beneath the sticky header.
 *  - Subsequent clicks on the button can hit the sticky header's icons
 *    (search, cart, theme toggle) instead of the button itself.
 *
 * Mount once inside <Router> but outside <Routes>.
 */
export default function ScrollToTop(): null {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // useLayoutEffect runs synchronously before the browser paints, so the
    // new route never displays at the old scroll position — no visible jump.
    // "auto" (not "smooth") is intentional: consistent with a fresh page
    // load and unaffected by prefers-reduced-motion.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
